<template>
  <div class="editor-screenshot-saver">
    <Previewer v-if = "showPreviewer" :project="project" :autoplay="true" ref="previewer" :showOverlay="false"> </Previewer>
    <div style="margin-top:1em; text-align:center;">
      <a id = "capture" @click="captureThumbnail" class="btn btn-left-icon btn-bg-colored btn-round btn-small"> <span class = "material-icons md-18">camera</span> <span>Capturar portada</span> </a>
    </div>

    <div id = "display-cover">
      <img v-if = "coverbase64" class = "cover" :src="coverbase64" />
      <img v-else-if = "remoteCover" class = "cover" :src="remoteCover" />
      <img v-else class = "cover" src = "/static/img/nocover.png" />
      <h2> Portada actual </h2>
    </div>
  </div>
</template>

<script>
import Previewer from '../Previewer/Previewer'

export default {
  name: 'EditorScreenshotSaver',
  components: {
    Previewer
  },
  props: {
    project: Object,
    showPreviewer: {
      default: true
    }
  },
  watch: {
    'project': function (oldRoute, newRoute) {
      this.coverbase64 = null
    }
  },
  data () {
    return {
      cover: null,
      coverbase64: null
    }
  },
  computed: {
    remoteCover () {
      return this.project.cover
    },
    displayCover () {
      if (this.remoteCover !== null || this.coverbase64 !== null) return true
      else return false
    }
  },
  methods: {
    captureThumbnail: function () {
      window.referencias = this.$refs.previewer
      var canvas1 = this.$refs.previewer.$refs.iframe.contentDocument.getElementsByTagName('canvas')[0]

      var cover = null
      var coverbase64 = null
      try {
        coverbase64 = canvas1.toDataURL()
        cover = this.dataURLtoFile(coverbase64, 'coverfile.png')
        // console.log(this.dataURLtoFile(cover, 'coverfile.png'))
      } catch (e) {
        console.log('Error capturing cover', e)
      }
      this.cover = cover
      this.coverbase64 = coverbase64

      if (this.cover !== null) {
        this.$store.dispatch('saveCoverProject', this.cover)
          .then(() => {
            this.$store.dispatch('fetchProject', this.project.id)
          // esto está muy mal optimizado no haría falta volver a recargar el proyecto, simplemente sobreescribir las variables que llegan de la respuesta de saveCoverProject
          })
      }
    },
    dataURLtoFile: function (dataURI, filename) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      // console.log(dataURI)
      var byteString
      if (dataURI.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(dataURI.split(',')[1])
      } else {
        byteString = unescape(dataURI.split(',')[1])
      }
      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ia], {type: mimeString})
    }
  },
  created () {
  },
  destroyed () {
  },
  beforeDestroy () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

#capture {
  display: inline-flex;
  align-items: center;
}

#display-cover {
  margin-top: 18px;

  h2 {
    text-align: center;
    padding: 10px;
  }

  .cover {
    border: 2px solid black;
    min-width: 192px;
    height: 157px;
  }
}

.editor-screenshot-saver {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  justify-content: initial;
}

</style>



// WEBPACK FOOTER //
// src/components/Editor/EditorScreenshotSaver.vue